import { classifyQuotaLevel, type QuotaPressureSubscriptionLike } from '@/lib/quota/deriveQuotaPressure';
import type { PendingCycleResetSubscriptionLike } from './pendingCycleResetAt';
import { resolveWalletRenewalEligibility, type WalletRenewalSubscriptionLike } from './resolveWalletRenewalEligibility';

export function resolveEarlyRenewalPrompt({ subscription, objective, now }: {
  subscription: (WalletRenewalSubscriptionLike & QuotaPressureSubscriptionLike & PendingCycleResetSubscriptionLike)
    | null | undefined;
  objective: string | null | undefined;
  now: Date;
}): 'pix' | 'grant' | null {
  if (!subscription || subscription.past_due) return null;
  const eligibility = resolveWalletRenewalEligibility({ subscription, now });
  if (!eligibility.ok) return null;
  // Course purchases grant the same wallet-backed plan period as wallet purchases.
  if (eligibility.path === 'grant') return 'grant';
  // Already paid: the renewed cycle waits for its start (RenewedCycleNotice offers
  // it now). Also once the instant passed, until the hourly job clears the field:
  // the old quota still counts until then.
  if (subscription.pending_cycle_reset_at) return null;
  const library = objective === 'other_channels';
  const used = (library ? subscription.current_month_library_video_seconds
    : subscription.current_month_processing_seconds) ?? 0;
  const max = (library ? subscription.plan?.max_library_video_seconds
    : subscription.plan?.processing_seconds) ?? 0;
  if (!Number.isFinite(used) || !Number.isFinite(max)) return null;
  return classifyQuotaLevel({ kind: 'time', used, max }) ? 'pix' : null;
}
